import wsReadCard from './wsReadCard'

const zhCN = { wsReadCard: wsReadCard.zhCN }
const enUS = { wsReadCard: wsReadCard.enUS }
export default { zhCN, enUS }